/*!
 * swatch-active — toggles `.active` class on `.variants-swatches` when it contains
 * a checked input. Replaces the jQuery handler that lived inline in layout/theme.liquid.
 * Existing CSS rules `.variants-swatches.active` continue to drive the visual.
 */
(function () {
  function update() {
    document.querySelectorAll('.variants-swatches').forEach(function (s) {
      s.classList.toggle('active', !!s.querySelector('input:checked'));
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.variants-swatches input')) {
      update();
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
